import React from 'react';
import { Form } from 'antd';
import dayjs from 'dayjs';

import { handleFormErrors } from '../common/errorHelpers';
import { useAddReminder } from '../common/useAddReminder';
import { FetchRemindersResponseType } from '../common/useGetClientReminders';
import { useRemindersTableColumnDefinitions } from '../features/reminders/useRemindersTableColumnDefinitions';
import { useRemindersTableDataSource } from '../features/reminders/useRemindersTableDataSource';

import { ReminderForm } from './ReminderForm';
import { TableWithDataUpdate } from './TableWithDataUpdate';

const mapErrorFieldsToFormLabels = {
  title: 'Title',
  text: 'Reminder note',
  user: 'User',
  type: 'Reminder type',
  date: 'Date',
};

type RemindersTableWithAddOptionProps = {
  objectId: string;
  data?: FetchRemindersResponseType;
  objectClass: string;
};

type ReminderFormValues = {
  date: dayjs.ConfigType;
  text: string;
  title: string;
  type?: string;
  user: string;
};

export const RemindersTableWithAddOption: React.FC<RemindersTableWithAddOptionProps> = ({
  objectId,
  data,
  objectClass,
}) => {
  const [form] = Form.useForm();
  const columns = useRemindersTableColumnDefinitions({ withLocalSorting: true });
  const addReminder = useAddReminder();

  const dataSource = useRemindersTableDataSource(data);

  const handleSave = (record: ReminderFormValues, successCallback?: () => void) => {
    const { date, text, title, type, user } = record;
    const payload = {
      data: {
        active: true,
        date: dayjs(date).unix(),
        objectClass: objectClass,
        objectUuid: objectId,
        text,
        title,
        type: type?.toUpperCase(),
        user: user,
      },
    };
    addReminder.mutate(payload, {
      onSuccess: successCallback,
      onError: (error) => {
        handleFormErrors({ error, form, mapErrorFieldsToFormLabels });
      },
    });
  };

  return (
    <div style={{ paddingBottom: '15px' }}>
      <TableWithDataUpdate
        title="Reminders"
        addButtonName="Add reminder"
        linkedCells={true}
        columns={columns}
        dataSource={dataSource}
        form={form}
        onSave={handleSave}
        itemForm={ReminderForm}
      />
    </div>
  );
};
